module.exports = __webpack_public_path__ + "img/pink3.04ff0258.jpg";